import { Component } from 'react';
import hanldeException from '../../../services/handleException';
import { settingMappingItemName } from './../../../constants/order';
import lang from './../../../languages/en';
import { fieldRequiredInformation, fieldRequiredItems, fieldRomaji, romajiNameOnlyCountries, yomiganaNotRequiredCountries, romajiAddressOnlyCountries, noPostalCodeCountries } from './../../../services/fieldRequired';
import { trimData } from './../../../services/helper';
import { regexIsRomanji, regexJapanese, regexName, regexPhone, validateEmail } from './../../../services/ruleValidate';
import Storage from './../../../services/Storage';
import { checkItemNameMapping } from './../../../utils/orders';
import { getMasterUpdateSetting } from './../../../utils/settingMerchant';
import { ListChannel } from './../../../constants/setting_channel';

class OrderComponent extends Component {
    constructor(props) {
        super(props)
        Storage.accessToken()
        this.state = {
            maxSizeSku: 60
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let maxSizeSku = nextProps.order.information.channel_short_name === ListChannel.RAKUTEN.ShortName ? 60 : 60;
        return {
            maxSizeSku
        };
    }

    onFocus = (value, column, pageType = null) => {
        let message = ''
        const { email } = this.props.information
        if (column === 'email' && email && (!validateEmail(value) || !regexIsRomanji(value))) {
            message = lang.email_invalid
            this.props.onChange({ value: column, column: 'tooltip' })
            this.props.onChange({ value: message, column: 'message' })
        }
        if ((column === 'channel_order' || column === 'phone') && value) {
            if (!regexIsRomanji(value)) {
                message = lang.prohibited_characters
                this.props.onChange({ value: column, column: 'tooltip' })
                this.props.onChange({ value: message, column: 'message' })
            }
        }
        if (column === 'postal_code') {
            if (value && this.props.classes.postal_code === 'warring') {
                message = lang.postal_code_exist
                this.props.onChange({ value: column, column: 'tooltip' })
                this.props.onChange({ value: message, column: 'message' })
            }
            this.props.onChange({ value: true, column: 'focusPostalCode' })
        } else {
            this.props.onChange({ value: false, column: 'focusPostalCode' })
        }
        if (column === 'yomigana' && (regexJapanese(value) || regexName(value))) {
            message = lang.prohibited_characters
            this.props.onChange({ value: column, column: 'tooltip' })
            this.props.onChange({ value: message, column: 'message' })
        }
        if (column === 'name') {
            if (pageType === 'editOrder' && this.props.order.manual_flag_bl) {
                this.props.onChange({ value: true, column: "restoreBtnDisable" })
            }

            if (regexName(value) || (regexJapanese(value) && romajiNameOnlyCountries.includes(this.props.information.country))) {
                message = lang.prohibited_characters
                this.props.onChange({ value: column, column: 'tooltip' })
                this.props.onChange({ value: message, column: 'message' })
            }
        }
        if (column === 'phone' && value && !regexPhone(value)) {
            message = lang.prohibited_characters
            this.props.onChange({ value: column, column: 'tooltip' })
            this.props.onChange({ value: message, column: 'message' })
        }
        if (column === 'Remark' && (regexJapanese(value) || regexName(value))) {
            message = lang.prohibited_characters
            this.props.onChange({ value: column, column: 'tooltip' })
            this.props.onChange({ value: message, column: 'message' })
        }
        if (column === 'address1'){
            if(regexJapanese(value) && romajiAddressOnlyCountries.includes(this.props.information.country)){
                message = lang.prohibited_characters
                this.props.onChange({ value: column, column: 'tooltip' })
                this.props.onChange({ value: message, column: 'message' })
            }
        }
        if (column === 'address2'){
            if(regexJapanese(value) && romajiAddressOnlyCountries.includes(this.props.information.country)){
                message = lang.prohibited_characters
                this.props.onChange({ value: column, column: 'tooltip' })
                this.props.onChange({ value: message, column: 'message' })
            }
        }
        if (column === 'address3'){
            if(regexJapanese(value) && romajiAddressOnlyCountries.includes(this.props.information.country)){
                message = lang.prohibited_characters
                this.props.onChange({ value: column, column: 'tooltip' })
                this.props.onChange({ value: message, column: 'message' })
            }
        }
        if (column === 'address4'){
            if(regexJapanese(value) && romajiAddressOnlyCountries.includes(this.props.information.country)){
                message = lang.prohibited_characters
                this.props.onChange({ value: column, column: 'tooltip' })
                this.props.onChange({ value: message, column: 'message' })
            }
        }
    }

    onBlur = (value, column) => {
        let data = this.props.information
        let classes = this.props.classes
        let errorOrder = this.props.order.error

        value = trimData(value)
        if (fieldRequiredInformation.indexOf(column) !== -1) {
            if (!value) {
                classes[column] = 'error'
            } else {
                classes[column] = ''
            }
        }
        if (column === 'email') {
            if (value) {
                if (!validateEmail(value) || !regexIsRomanji(value)) {
                    classes[column] = 'error'
                    if (errorOrder.indexOf('email') === -1) {
                        errorOrder.push('email')
                    }
                } else {
                    classes[column] = ''
                    let index = errorOrder.indexOf('email')

                    if (index !== -1) {
                        errorOrder.splice(index, 1)
                    }
                }
            } else {
                classes[column] = ''
                let index = errorOrder.indexOf('email')

                if (index !== -1) {
                    errorOrder.splice(index, 1)
                }
            }
        }
        if (fieldRomaji.indexOf(column) !== -1) {
            if (value) {
                if (!regexIsRomanji(value)) {
                    classes[column] = 'error'
                } else {
                    classes[column] = ''
                }
            }
        }
        if (column === 'yomigana' ) {
            if(!yomiganaNotRequiredCountries.includes(data.country)){
                if (!value || regexJapanese(value) || regexName(value)) {
                    classes.yomigana = 'error'
                } else {
                    classes.yomigana = ''
                }
            }else{
                if (regexJapanese(value) || regexName(value)) {
                    classes.yomigana = 'error'
                } else {
                    classes.yomigana = ''
                }
            }
        }
        if (column === 'Remark') {

            let index = errorOrder.indexOf('Remark')
            if (regexJapanese(value)) {
                classes.Remark = 'error'
                errorOrder.push('Remark')
            } else {
                classes.Remark = ''
                errorOrder.splice(index, 1)
            }
        }
        if (column === 'phone' && value) {
            if (!regexPhone(value)) {
                classes.phone = 'error'
            } else {
                classes.phone = ''
            }
        }
        if (column === 'name' && value) {
            if (regexName(value)) {
                classes.name = 'error'
            } else {
                classes.name = ''
            }
            if(regexJapanese(value) && romajiNameOnlyCountries.includes(data.country)){
                classes.name = 'error'
            }
            if (!data.yomigana) {
                let data = {
                    OriginalString: value
                }
                this.props.convertName(data)
                this.props.onChange({ value: false, column: 'restoreBtnDisable' })
            }
        }
        if (column === 'address1') {
            if (regexJapanese(value) && romajiAddressOnlyCountries.includes(data.country)) {
                classes.address1 = 'error'
            }
        }
        if (column === 'address2') {
            if (regexJapanese(value) && romajiAddressOnlyCountries.includes(data.country)) {
                classes.address2 = 'error'
            }
        }
        if (column === 'address3') {
            if (regexJapanese(value) && romajiAddressOnlyCountries.includes(data.country)) {
                classes.address3 = 'error'
            } else {
                classes.address3 = ''
            }
        }
        if (column === 'address4') {
            if (regexJapanese(value) && romajiAddressOnlyCountries.includes(data.country)) {
                classes.address4 = 'error'
            } else {
                classes.address4 = ''
            }
        }
        this.props.onChange({ value: '', column: 'tooltip' })
        this.props.onChange({ value: errorOrder, column: 'error' })
        this.props.onChangeInformation({ value, column })
        this.props.onChangeClasses(classes)
    }

    onChangeItemSearch = (value, condition, column) => {
        let collectItem = [...this.props.order.checked_search_item]

        if (condition) {
            collectItem.push(value)
        }
        this.props.onChange({ value: collectItem, column: 'checked_search_item' })
    }

    changeValidateEmpty = (value, column) => {
        this.props.onChange({ value: lang.field_required, column: 'message' })
        this.props.onChange({ value: column, column: 'tooltip' })
    }

    changeValidateNotEmpty = (value, column) => {
        this.props.onChange({ value: '', column: 'message' })
        this.props.onChange({ value: '', column: 'tooltip' })
    }
    validateEmpty = (value, column) => {
        const { order, order: { information : { channel_short_name} } } = this.props
        if (!value) {
            if (column === 'yomigana' && !this.props.order.focusName && !yomiganaNotRequiredCountries.includes(this.props.information.country)) {
                this.changeValidateEmpty(value, column)
            }
            if ((column === 'address1' || column === 'address2') && !order.focusPostalCode) {
                this.changeValidateEmpty(value, column)
            }
            if (column !== 'yomigana' && column !== 'address1' && column !== 'address2') {
                // case column is channel_order_item
                if (column.indexOf('channel_order_item_') !== -1) {
                    if (channel_short_name === ListChannel.AMAZON_JP.ShortName) {
                        this.changeValidateEmpty(value, column)
                    } else {
                        this.changeValidateNotEmpty(value, column)
                    }
                } else {
                    this.changeValidateEmpty(value, column)
                }
            }
            this.props.onChange({ value: false, column: 'focusPostalCode' })
        }
        if (column === 'name' && value) {
            this.props.onChange({ value: true, column: 'focusName' })
        } else {
            this.props.onChange({ value: false, column: 'focusName' })
        }
        if (column === 'postal_code' && value){
            this.props.onChange({ value: true, column: 'postal_code' })
        } else {
            this.props.onChange({ value: false, column: 'postal_code' })
        }
        if (column === 'address1' && value){
            this.props.onChange({ value: true, column: 'address1' })
        } else {
            this.props.onChange({ value: false, column: 'address1' })
        }
        if (column === 'address2' && value){
            this.props.onChange({ value: true, column: 'address2' })
        } else {
            this.props.onChange({ value: false, column: 'address2' })
        }
    }

    validateRequiredItem = () => {
        let error = 0;
        let items = [...this.props.itemOrder]
        let { information: { channel_short_name } } = this.props.order
        let classes = this.props.classes
        let fieldRequiredItemsTemp = [...fieldRequiredItems]
        if (channel_short_name !== ListChannel.AMAZON_JP.ShortName) {
            //remove require channel_order_item
            let index = fieldRequiredItemsTemp.indexOf('channel_order_item');
            if (index !== -1) fieldRequiredItemsTemp.splice(index, 1)
        }

        for (let i = 0; i < items.length; i++) {
            for (let j = 0; j < fieldRequiredItemsTemp.length; j++) {
                if (!items[i][fieldRequiredItemsTemp[j]]) {
                    error++
                    items[i]['classes'][fieldRequiredItemsTemp[j]] = 'error'
                }
            }
            for (let k = 0; k < fieldRomaji.length; k++) {
                if (items[i][fieldRomaji[k]]) {
                    if (fieldRomaji[k] !== 'item_name') {
                        if (!regexIsRomanji(items[i][fieldRomaji[k]])) {
                            error++
                            items[i]['classes'][fieldRomaji[k]] = 'error'
                        } else {
                            items[i]['classes'][fieldRomaji[k]] = ''
                        }
                    }
                }
            }

            let value_item_sku = items[i].sku;
            if (!items[i]['classes'].sku) {
                if (value_item_sku && value_item_sku.length > this.state.maxSizeSku) {
                    error++
                    items[i]['classes'].sku = 'error'
                } else {
                    items[i]['classes'].sku = ''
                }
            }
        }
        this.props.onChangeClasses(classes)
        return error;
    }

    validateError = () => {
        if (!this.props.order.error || this.props.order.error.length < 1) {
            return true
        }
        return false;
    }

    validateRequired = (save) => {
        let information = this.props.information
        let fieldRequired = fieldRequiredInformation
        let classes = this.props.classes
        let error = 0;

        if(noPostalCodeCountries.includes(information.country)){
            fieldRequired.splice(fieldRequired.indexOf('postal_code'), 1)
        }
        if (save) {
            if (information.name) {
                let index = fieldRequired.indexOf('yomigana')

                if (index !== -1) {
                    fieldRequired.splice(index, 1)
                }
            }
        }
        for (let i = 0; i < fieldRequired.length; i++) {
            if (!information[fieldRequired[i]]
                || (fieldRequired[i] === 'name'
                && information[fieldRequired[i]]
                && regexName(information[fieldRequired[i]]))) {
                error++
                classes[fieldRequired[i]] = 'error'
            } else {
                classes[fieldRequired[i]] = ''
            }
        }
        for (let j = 0; j < fieldRomaji.length; j++) {
            if (information[fieldRomaji[j]]) {
                if (!regexIsRomanji(information[fieldRomaji[j]]) && !romajiNameOnlyCountries.includes(information.country)) {
                    error++
                    classes[fieldRomaji[j]] = 'error'
                } else {
                    classes[fieldRomaji[j]] = ''
                }
            }
        }
        if (information.yomigana) {
            if (regexJapanese(information.yomigana) || regexName(information.yomigana)) {
                classes.yomigana = 'error'
                error++
            } else {
                classes.yomigana = ''
            }
        }
        if (information.phone) {
            if (!regexPhone(information.phone)) {
                classes.phone = 'error'
                error++
            } else {
                classes.phone = ''
            }
        }

        if(romajiNameOnlyCountries.includes(information.country)){
            if(regexJapanese(information.name) || regexName(information.name)){
                classes.name = 'error'
                error++
            }
        }
        if(romajiAddressOnlyCountries.includes(information.country)){
            if(regexJapanese(information.address1) || regexName(information.address1)){
                classes.address1 = 'error'
                error++
            }
            if(regexJapanese(information.address2) || regexName(information.address2)){
                classes.address2 = 'error'
                error++
            }
            if(regexJapanese(information.address3) || regexName(information.address3)){
                classes.address3 = 'error'
                error++
            }else{
                classes.address3 = ''
            }
            if(regexJapanese(information.address4) || regexName(information.address4)){
                classes.address4 = 'error'
                error++
            }else{
                classes.address4 = ''
            }
        }
        error += this.validateRequiredItem()
        this.props.onChangeClasses(classes)
        return error === 0;
    }

    convertItems = (value) => {
        let itemOrder = [...this.props.itemOrder]
        let itemNew = []
        let confirmItemName = this.props.order.dataMappingItem
        if (value === 'confirmSuccess' && confirmItemName) {
            itemOrder = itemOrder.map((e, i) => {
                confirmItemName.map((ec, ic) => {
                    if (e.sku === ec.sku) {
                        if (ec.checkedMap) {
                            e.CheckedMapping = 1
                        } else {
                            e.CheckedMapping = 0
                        }
                    }
                    return ec;
                })
                return e;
            })
        }
        if(value === 'notAsk') {
            itemOrder = itemOrder.map((e, i) => {
                e.CheckedMapping = 1
                return e;
            })
        }
        for (let i = 0; i < itemOrder.length; i++) {
            itemNew.push({
                ChannelOrderItem: itemOrder[i]['channel_order_item'],
                ItemCode: itemOrder[i]['item_code'],
                ItemName: itemOrder[i]['item_name'],
                SKU: itemOrder[i]['sku'],
                AdjustedValue: itemOrder[i]['price_adjusted'],
                ItemValue: itemOrder[i]['item_value'] ? itemOrder[i]['item_value'] : itemOrder[i]['price_adjusted'],
                AdjustmentValue: itemOrder[i]['price_adjustment'],
                PCS: itemOrder[i]['qty'],
                Origin: itemOrder[i]['origin'],
                CheckedMapping: itemOrder[i]['CheckedMapping'],
                LastUpdateItemDT: itemOrder[i]['LastUpdateItemDT'],
                HasApproveKeyWordBL: itemOrder[i]['HasApproveKeyWordBL'],
                HasApproveKeyWordBLOrigin: itemOrder[i]['HasApproveKeyWordBL'],
                GSTPaid: itemOrder[i]['gst_paid']
            })
        }
        return itemNew
    }

    settingMappingItemName = () => {
        getMasterUpdateSetting().then(res => {
            if (res.data.code === 10001) {
                this.props.onChange({ value: res.data.data, column: 'settingMappingItemName' })
            } else {
                hanldeException(res)
            }
        }).catch(err => {
            hanldeException(err)
        })
    }

    confirmItemNameMapping = () => {
        let data = this.convertData()
        this.props.onChange({ value: true, column: 'isLoading' })
        checkItemNameMapping(data).then(res => {
            if (res.data.code === 10001) {
                this.setState({
                    listItemMapping: res.data.data.checkOrder,
                    popUp: res.data.data.popUp
                }, () => {
                    let checkStatus = []
                    this.state.listItemMapping.map((e, i) => {
                        if (e.Status !== 2) {
                            checkStatus.push(i)
                        }
                        return false;
                    })
                    let settingMapping = this.props.order.settingMappingItemName
                    if (!checkStatus.length
                        || settingMapping === settingMappingItemName.NEVER_UPDATE
                        || settingMapping === settingMappingItemName.WITHOUT_ASK_ME) {
                        if (!this.state.popUp) {
                            this.onSaveOrders('notAsk');
                        } else {
                            this.props.onChange({ value: true, column: 'modalTypeMappingItem' })
                            this.props.onChange({ value: false, column: 'isLoading' })
                        }
                    } else {
                        this.translationItemNameRef.loadData()
                        this.props.onChange({ value: false, column: 'isLoading' })
                        this.props.onChange({ value: true, column: 'modalMappingItem' })
                    }
                })
            } else if (res.data.code === 211140) {
                let classes = this.props.classes
                classes.channel_order = 'error'
                this.props.onChangeClasses(classes)
                this.props.onChange({ value: false, column: 'isLoading' })
                hanldeException(res)
            } else {
                hanldeException(res)
                this.props.onChange({ value: false, column: 'isLoading' })
            }

        }).catch(err => {
            hanldeException(err)
            this.props.onChange({ value: false, column: 'isLoading' })
        })
    }

    confirmMapping = (type) => {
        if (!this.props.order.SKUDuplicateOrderOther || type === 'notMappingOrderOther') {
            this.props.onChange({ value: false, column: 'modalMappingItem' })
            this.asyncMapping(); return;
        }
        this.props.onChange({ value: false, column: 'isLoading' })
        this.asyncMappingCheckData()
    }

    async asyncMapping() {
        await this.props.onChange({ value: 3, column: 'mappingOrderSameSku' })
        await this.getValueItem()
        await this.onSaveOrders('confirmSuccess')
    }

    async asyncMappingCheckData() {
        await this.props.onChange({ value: 1, column: 'mappingOrderSameSku' })
        await this.getValueItem()
        await this.props.onChange({ value: true, column: 'modalTypeMappingItem' })
    }

    getValueItem = () => {
        let data = this.translationItemNameRef.getValue()
        this.props.onChange({ value: data, column: "dataMappingItem" })
    }

    confirmTypeMapping = () => {
        this.onSaveOrders('confirmSuccess');
        this.props.onChange({ value: false, column: 'modalMappingItem' })
        this.props.onChange({ value: false, column: 'modalTypeMappingItem' })
    }
}

export default OrderComponent



// WEBPACK FOOTER //
// ./src/containers/orders/components/index.js